import React from "react";
//#region types
import { RadioSelectionProps } from "models/propTypes/radioPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { RadioGroup, Radio, FormControlLabel, ButtonBase } from "@mui/material";
import Icon from "../../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const RadioSelectionGroup: React.FC<RadioSelectionProps> = (props) => {
  return (
    <RadioGroup {...props}>
      {props.items.map((item, index) => (
        <ButtonBase
          key={index}
          component="div"
          className={cssExports.radioSelection}
          TouchRippleProps={{ classes: { ripple: cssExports.touchRippleRoot } }}
          style={{ justifyContent: "flex-start" }}
        >
          <FormControlLabel
            // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if fixed
            className={item.id == props.value ? cssExports.checked : ""}
            key={item.id}
            value={item.id}
            label={
              item.description ? (
                <span className={cssExports.radioSelectionLabel}>
                  {item.value}
                  <span className={cssExports.radioSelectionDescription}>{item.description}</span>
                </span>
              ) : (
                item.value
              )
            }
            control={
              <Radio
                icon={<Icon icon={IconDefinitionConstants.WRadio} />}
                checkedIcon={<Icon icon={IconDefinitionConstants.WRadioChecked} />}
                classes={{ root: cssExports.radioRoot, checked: cssExports.checked }}
                disabled={props.readOnly}
              />
            }
          />
        </ButtonBase>
      ))}
    </RadioGroup>
  );
};

export default RadioSelectionGroup;
